export const PREVIEW_DISCLAIMER = "AI-generated illustration for inspiration only. Not a guarantee of final results.";

const Pane = ({ label, src, testId }) => (
  <figure className="min-w-0">
    <figcaption className="mb-1.5 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-muted-foreground">{label}</figcaption>
    <a href={src} target="_blank" rel="noopener noreferrer" className="block overflow-hidden rounded-xl bg-slate-100 ring-1 ring-slate-200 dark:bg-muted dark:ring-border" data-testid={`${testId}-link`}>
      <img src={src} alt={label} className="block h-auto max-h-[70vh] w-full object-contain" data-testid={testId} />
    </a>
  </figure>
);

export const BeforeAfter = ({ before, after, testId = "before-after" }) => (
  <div data-testid={testId}>
    <div className="grid grid-cols-2 gap-2.5">
      <Pane label="Before" src={before} testId={`${testId}-before-img`} />
      <Pane label="After" src={after} testId={`${testId}-after-img`} />
    </div>
    <p className="mt-2.5 text-xs leading-snug text-slate-500 dark:text-muted-foreground" data-testid={`${testId}-disclaimer`}>{PREVIEW_DISCLAIMER}</p>
  </div>
);
